export const faqs = [
  {
    q: "「考古坞」到底在做什么？",
    a: "我们把过去二十多年娱乐行业里被时间盖住的人和事重新翻出来，做年代梳理、旧料核对和背景补全。不是追新，而是把旧的东西重新讲清楚。",
  },
  {
    q: "这里的旧料是从哪来的？",
    a: "公开的节目录像、当年的报纸杂志、论坛存档，以及当事人多年后接受的采访。凡是无法核实的说法，我们都会在文中标明「未获证实」，不做定论。",
  },
  {
    q: "看到和自己有关的旧料，可以要求处理吗？",
    a: "可以。如果文中信息有误、涉及隐私，或你希望删除某条内容，通过页面底部的联系表单说明即可，我们会在核实后补充更正或撤下。",
  },
  {
    q: "为什么有些人物只用姓氏或代号？",
    a: "涉及到未经证实的说法时，我们会做匿名处理，只保留事件本身。考古的重点是把事情讲清楚，不是把某个人再推上一次风口。",
  },
  {
    q: "年代索引是怎么划分的？",
    a: "按事件发生的年份归档，分成 1990 年代、2000 年代、2010 年代和 2020 年代四个区间。点击任意年代即可查看该区间的全部条目。",
  },
  {
    q: "可以投稿或者提供线索吗？",
    a: "非常欢迎。你可以通过订阅与联系表单留下线索，最好附上大致年份和可查证的出处。有出处的线索我们优先处理。",
  },
  {
    q: "更新频率是怎样的？",
    a: "每周更新两到三篇。年代越久、资料越散的条目，整理时间会越长，因此发布节奏不固定，但不会停止。",
  },
];